


















import { Vue, Component, Watch } from "@/shared/vuepack";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import IconCard from "@/employer/components/shared/IconCard.vue";
import { PRODUCTS_ICONS_MAP } from "@/shared/constants/productsIconsMap";

const UnknownErrorMessage = "Error processing your request. Please try again later";

@Component ({
components: {
    IconCard,
}
})
export default class Products extends Vue {
  userStore = useUserStore();
  notifierStore = useNotifierStore();

  get iconMap () {
      return PRODUCTS_ICONS_MAP;
  }

  get products () {
    return this.userStore.partnerProducts;
  }

  created () {
    this.userStore.getEmployerProducts();
  }

  handleError (err): void {
      this.notifierStore.setDanger(err.errorMessage || UnknownErrorMessage);
  }
}
